import { render, staticRenderFns } from "./ForumResponseBodyTextOutputNode.vue?vue&type=template&id=133a48a4"
import script from "./ForumResponseBodyTextOutputNode.vue?vue&type=script&lang=js"
export * from "./ForumResponseBodyTextOutputNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports